import axios from '@/axios.js'
import state from './state';

export default {

  changeServicesAppearance({ commit }, appearance) {
    commit('SERVICES_APPEARANCE', appearance);
  },

  async convertService({ commit, dispatch }, id) {
    try {
      const request = await axios.post('/client/services/convert', { services: [ id ] });

      dispatch('notification/notification', request, {
        root: true
      });

      if (request.data.success === false) {
        return;
      }

      dispatch('user/updateServices', {
        type: 'remove',
        services: [ { id } ],
      }, {
        root: true
      });

      dispatch('user/updateBalance', {
        amount: request.data.transactions[0].credit,
        type: 'credit',
      }, {
        root: true
      });

      commit('SERVICES_CONVERT', id);
    } catch(e) {}
  },

  async fetchServices({ commit }) {
    if (state.servicesLoading) {
      return;
    }

    state.servicesLoading = true;
    const request = await axios.get('/client/services');

    if (request.data.success === false) {
      request.data.services = [];
    }

    commit('SERVICES'         , request.data.specialists);
    commit('SERVICES_METADATA', request.data.metadata);
  },
}
